'use strict';

const _ = require('lodash');
const Classnames = require('classnames');

const React = require('react');
const ReactRouter = require('react-router');

const Link   = ReactRouter.Link;

const Constants = require('../../constants');
const Global = require('../../global');
const ResponsiveMixin = Global.ResponsiveMixin;

const isNode = typeof document === 'undefined';
if (!isNode) {
    require('./stackable-tabs.scss');
}

const StackableTabs = React.createClass({
    mixins: [ ResponsiveMixin ],

    propTypes: {
        // Location as injected into Route component by React Router
        location: React.PropTypes.shape({
            pathname: React.PropTypes.string,
        }).isRequired,

        // URL and Title for all tabs
        tabs: React.PropTypes.arrayOf(
            React.PropTypes.shape({
                url: React.PropTypes.string,
                title: React.PropTypes.string,
            })
        ).isRequired,

        // Content to render for current tab
        content: React.PropTypes.node.isRequired,

        // Reset scroll to top of page on tab change, if set to true
        resetScrollOnNavigation: React.PropTypes.bool,

        // Compare styling of Landing page and Project form tabs
        theme: React.PropTypes.oneOf([ 'landing', 'project' ]).isRequired,

        // If the currently selected tab on mobile is selected, close the tab and change to this location
        root: React.PropTypes.string,
    },
    getDefaultProps: function() {
        return {
            resetScrollOnNavigation: false,
        };
    },

    render: function() {
        const _this = this;
        let tabIx = _.findIndex(this.props.tabs, function(o) {
            return o.url == _this.props.location.pathname;
        });

        // Default to first tab (for the Landing page /full-service-overview in which the leftmost tab has
        // a URL /full-service-overview/office-furniture-desk distinct from the page itself)
        if (this.state.viewportLayout == 'desktop' && tabIx === -1) {
            tabIx = 0;
        }
        
        const orientation = this.state.viewportLayout == 'desktop' ? 'desktop' : 'mobile';

        return (
            <div className='st'>
                {this.props.tabs.map((tab, ix) => {
                    const classes = Classnames({
                        'st-step':     true,
                        'st-active':   ix == tabIx,
                        'st-inactive': ix != tabIx,
                        'st-last':     ix == this.props.tabs.length - 1,  // last tab is 1px wider on desktop (if 3 tabs), and slightly deeper on mobile
                        'st-joiner':   this.props.theme == 'project' && ix > tabIx,
                        'st-theme-landing': this.props.theme == 'landing',
                        'st-theme-project': this.props.theme == 'project',
                    });
                    
                    let joiner = null;
                    if (ix == tabIx + 1) {
                        joiner = 2;
                    } else if (ix >= tabIx + 2) {
                        joiner = 4;
                    }

                    let control;
                    if (this.state.viewportLayout != 'desktop' && this.props.theme == 'landing') {
                        if (ix == tabIx) {
                            control = 'images/global/expansion/minus-grey1.png';
                        } else {
                            control = 'images/global/expansion/plus-grey1.svg';
                        }
                    }

                    let target;
                    if (this.state.viewportLayout != 'desktop' && ix == tabIx && this.props.root) {
                        target = this.props.root;
                    } else {
                        target = tab.url;
                    }

                    return (
                        <div className='st-enclosure' key={ix}>
                            <Link className={classes} to={{
                                pathname: target,
                                state: {
                                    scroll: orientation != 'desktop' && this.props.resetScrollOnNavigation
                                }
                            }}>
                                {this.state.viewportLayout != 'desktop' && this.props.theme == 'project' && joiner ?
                                    <img src={`${Constants.static}images/stackable-tabs/mobile/joiner-grey${joiner}.png`} />
                                : null}
                                <div className='st-label'>
                                    {tab.title}
                                </div>
                                {control ?
                                    <div className='st-expansion'>
                                        <img src={Constants.static + control} />
                                    </div>
                                : null}
                            </Link>
                            {orientation == 'mobile' && ix == tabIx ?
                                <div className='pf-content'>
                                    {this.props.content}
                                </div>
                            : null}
                        </div>
                    );
                })}
                {orientation == 'desktop' ?
                    this.props.content
                : null}
            </div>
        );
    },
});

module.exports = StackableTabs



// WEBPACK FOOTER //
// ./src/plugins/stackable-tabs/stackable-tabs.jsx